import { render } from "./reversi.vue?vue&type=template&id=4686b940"
import script from "./reversi.vue?vue&type=script&lang=js"
export * from "./reversi.vue?vue&type=script&lang=js"

import "./reversi.vue?vue&type=style&index=0&id=4686b940&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__